module.exports = __webpack_public_path__ + "img/character-fish-happy.de3e9975.svg";